module.exports = __webpack_public_path__ + "static/img/point1.1057ef95.png";